export const LOG_MUTATION = `
  mutation logMessage ($message: String!, $level: Level!, $key: String!, $client: String!, $data: [DataInput!]!) {
    logMessage(message: $message, level: $level, key: $key, client: $client, data: $data) {
      error
      success
    }
  }
`;
